'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'meteor';
var width = 512;
var height = 512;
var aliases = [9732];
var unicode = 'f753';
var svgPathData = ['M32 309c0 94.4 76.5 171 171 171 61 0 117.4-32.5 148-85.3l86.9-150.1-48.5 3.7c5-13.9 28.2-79 69.8-195.4-116.4 41.6-181.6 64.8-195.4 69.8l3.7-48.5-150.1 86.9C64.5 191.6 32 248 32 309zm296 3a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z', 'M304 16l-33.6 19.4-169.1 97.9C38.6 169.7 0 236.6 0 309 0 421.1 90.9 512 203 512 275.4 512 342.3 473.4 378.6 410.7L476.6 241.6 496 208c-40 3.1-43 3.3-59.9 4.6 1.4-4.1 22.1-62 62-173.7L512 0c-9 3.2-68.9 24.6-179.6 64.1l-33 11.8c2.5-32.5 3.2-41.2 4.6-59.9zM117.3 161.1l150.1-86.9-3.7 48.5c13.9-5 79-28.2 195.4-69.8-41.6 116.4-64.8 181.6-69.8 195.4l48.5-3.7-86.9 150.1c-30.6 52.8-87 85.3-148 85.3-94.4 0-171-76.5-171-171 0-61 32.5-117.4 85.3-148zM296 312a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM200 184a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm8 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm16 88a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMeteor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;